import Constants from "../../utils/Constants";

export const LoginAction = (payload) => {
  return {
    type: Constants.loginAction,
    payload,
  };
};
